const ValueHelperConfiguration = {
    default_money_sign: '£',
    default_money_round: true,
}

export default ValueHelperConfiguration;
